import Vue from 'vue';
import { BootstrapVue } from 'bootstrap-vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import VueFilterDateFormat from '@vuejs-community/vue-filter-date-format';
import VueFilterDateParse from '@vuejs-community/vue-filter-date-parse';
import Amplify from 'aws-amplify';
import { abilitiesPlugin } from '@casl/vue';
import { CookieStore } from '@switchsystems/aws-amplify-helper';
import VueMeta from 'vue-meta';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import '@aws-amplify/ui-vue';
import App from './App.vue';
import awsExports from './aws-exports';
import i18n from './i18n';
import store from './store';
// eslint-disable-next-line import/no-named-as-default-member, import/no-named-as-default
import router from './router';
import './icons';

Amplify.configure(awsExports);

const deviceTracking = store.getters['auth/getRememberDevice'];
CookieStore.configure({
  deviceTracking,
});

const bootstrapVueOptions = {
  formTextControls: {
    autocomplete: 'off',
  },
};

Vue.use(abilitiesPlugin, store.getters['auth/ability']);
Vue.use(BootstrapVue, bootstrapVueOptions);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true,
});
Vue.use(VueFilterDateFormat);
Vue.use(VueFilterDateParse);
Vue.config.productionTip = false;
Vue.component('font-awesome-icon', FontAwesomeIcon);
Vue.component('v-select', vSelect);

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
